<script>
import { mapState, mapMutations } from 'vuex';

export default {
  props: {
    remoteFilter: Object,
    reportKey: String,
  },

  computed: {
    ...mapState('reports', {
      meta(state) {
        return (state.reportData[this.reportKey] || {}).meta || {};
      },
      localFilter(state) {
        return state.localFilters[this.reportKey];
      },
    }),
  },

  methods: {
    ...mapMutations('reports', ['setLocalFilter']),
    getRemoteSubValueOrDefault(propName, defaultValue) {
      return (this.remoteFilter || {})[propName] || defaultValue;
    },
    setRemoteValue(propName, value) {
      const copy = { ...this.remoteFilter };
      if (copy[propName] === value) {
        return;
      }
      copy[propName] = value;
      this.$emit('update:remoteFilter', copy);
    },
    getLocalSubValueOrDefault(propName, defaultValue) {
      return (this.localFilter || {})[propName] || defaultValue;
    },
    setLocalValue(propName, value) {
      const filter = { ...this.localFilter };
      if (filter[propName] === value) {
        return;
      }
      filter[propName] = value;
      this.setLocalFilter({ reportKey: this.reportKey, filter });
    },
  },
};
</script>
